import ServiceTimeStep from 'components/OrderSteps/ServiceTimeStep/ServiceTimeStep'
import Modal, { ModalRef } from 'components/common/Modal/Modal'
import {
  useAppDispatch,
  useAppSelector
} from 'components/hooks/redux-selectors'
import { SET_SERVICE_TIME_DETAILS } from 'constants/actionTypes'
import s from './SelectServiceTimeModal.module.css'
import React, { RefObject } from 'react'

type Props = {
  modalRef: RefObject<ModalRef>
}

const SelectServiceTimeModal = ({ modalRef }: Props) => {
  const { serviceTime, deliveryDate } = useAppSelector(
    (state) => state.serviceDeliveryOptions
  )

  const formData = {
    deliveryDate: deliveryDate ?? '',
    serviceTime: serviceTime
  }

  const dispatch = useAppDispatch()

  return (
    <Modal className={s.modal} ref={modalRef}>
      <div className="flex h-full flex-col px-8 pt-20 pb-10">
        <ServiceTimeStep
          submitButtonText="Confirm"
          onSubmit={(data) => {
            dispatch({
              type: SET_SERVICE_TIME_DETAILS,
              payload: data
            })

            modalRef.current?.closeModal()
          }}
          showLeftArrow={false}
          formData={formData}
        />
      </div>
    </Modal>
  )
}

export default SelectServiceTimeModal
